import { useState, useEffect } from 'react'
import ReactMarkdown from 'react-markdown'
import { Table, Row, Col, Typography, Divider, Tabs } from 'antd'
import Comments from '../comments/Comments'
import FinancialsFilings from './FinancialsFilings'

const { Title } = Typography
const IpoContent = ({ ipoData }) => {
  const { attributes } = ipoData
  const related = 'api::ipo.ipo'
  const [href, setHref] = useState('')
  const [toggleTab, setToggleTab] = useState(true)
  const { TabPane } = Tabs

  const financialDataObj = {
    name: ipoData.attributes.name,
    revenue: ipoData.attributes.revenue,
    net_income: ipoData.attributes.net_income,
    total_assets: ipoData.attributes.total_assets,
    total_liabilities: ipoData.attributes.total_liabilities,
    stock_holders_equity: ipoData.attributes.stock_holders_equity,
    form_type: ipoData.attributes.form_type,
    date_received: ipoData.attributes.date_received,
    filing_link: ipoData.attributes.filing_link,
  }
  useEffect(() => {
    if (!['--', ' -- '].includes(attributes.website)) {
      const str = attributes.website
      const div = document.createElement('div')
      div.innerHTML = str
      const a = div.querySelector('a')
      setHref(a.getAttribute('href'))
    }
  }, [])
  const columns = [
    {
      title: 'Attribute',
      dataIndex: 'attribute',
      key: 'attribute',
      render: (text) => <b>{text}</b>,
    },
    {
      title: 'Value',
      dataIndex: 'value',
      key: 'value',
      render: (text) => {
        if (attributes.website && text === attributes.website) {
          return <a href={href}>{href}</a>
        }
        return text
      },
    },
  ]
  const dataSource = [
    {
      attribute: 'Proposed Symbol',
      value: `${attributes.symbol}`,
    },
    {
      attribute: 'Company Name',
      value: `${attributes.name}`,
    },
    {
      attribute: 'Exchange',
      value: `${attributes.exchange}`,
    },
    {
      attribute: 'Share Price',
      value: `${attributes.share_price}`,
    },
    {
      attribute: 'Employees',
      value: `${attributes.employees}`,
    },
    {
      attribute: 'Status',
      value: `${attributes.status}`,
    },
    {
      attribute: 'Shares Offered',
      value: `${attributes.shares_offered}`,
    },
    {
      attribute: 'Offer amount',
      value: `${attributes.offer_amount}`,
    },
    {
      attribute: 'Shares Over Alloted',
      value: `${attributes.shares_over_alloted}`,
    },
    {
      attribute: 'Company Address',
      value: `${attributes.address}`,
    },
    {
      attribute: 'Company Phone',
      value: `${attributes.phone}`,
    },
    {
      attribute: 'Company Website',
      value: `${
        attributes.website === '--' || attributes.website === ' -- '
          ? 'N/A'
          : attributes.website
      }`,
    },
    {
      attribute: 'CEO',
      value: `${attributes.ceo}`,
    },
    {
      attribute: 'State of Inc',
      value: `${attributes.state_inc}`,
    },
    {
      attribute: 'Fiscal Year End',
      value: `${attributes.fiscal_year_end}`,
    },
    {
      attribute: 'Total Offering Expense',
      value: `${attributes.offering_expense}`,
    },
    {
      attribute: 'Shareholder Shares Offered',
      value: `${attributes.shares_offered}`,
    },
    {
      attribute: 'Shares Outstanding',
      value: `${attributes.shares_outstanding}`,
    },
    {
      attribute: 'Lockup Period (days)',
      value: `${attributes.lockup_days}`,
    },
    {
      attribute: 'Lockup Expiration',
      value: `${attributes.lockup_expiration}`,
    },
    {
      attribute: 'Quiet Period Expiration',
      value: `${attributes.quiet_period_expiration}`,
    },
    {
      attribute: 'CIK',
      value: `${attributes.cik}`,
    },
    {
      attribute: 'DealId',
      value: `${attributes.deal_id}`,
    },
  ]

  return (
    <Row className="page-wrapper page" gutter={[16, 16]}>
      <Col xs={24} md={16} lg={18} span={12}>
        <Title className="title-wrapper">{attributes.name}</Title>
        <Tabs
          defaultActiveKey="1"
          onTabClick={(e) => {
            setToggleTab(e === '1')
          }}
        >
          <TabPane tab="Overview" key="1">
            <Title className="title-wrapper">Company Overview</Title>
            {toggleTab && (
              <Table
                columns={columns}
                dataSource={dataSource}
                bordered
                showHeader={false}
                pagination={false}
              />
            )}
            <br />
            <Title className="title-wrapper">Company Description</Title>
            <ReactMarkdown>{attributes.description}</ReactMarkdown>
          </TabPane>

          <TabPane tab="Financials & Filings" key="2">
            {!toggleTab && <FinancialsFilings propData={financialDataObj} />}
          </TabPane>
        </Tabs>
        <Divider style={{ color: '#1890ff' }}>Still got Doubts?</Divider>
        <Comments articleData={ipoData} related={related} />
      </Col>
    </Row>
  )
}
export default IpoContent
